import { getNavigabilityInteractions } from "../layers/interactions/navigability";
import { getGradientInteractions } from "../layers/interactions/gradient";
import { getDualCarriagewayInteractions } from "../layers/interactions/dualCarriageway";
import { getOnewayInteractions } from "../layers/interactions/oneway";
import { getDualCarriagewayStyleNormal } from "../layers/style/dualCarriageway";
import { getOnewayStyleNormal } from "../layers/style/oneway";
import { getOsmOnewayStyleNormal } from "../layers/style/osmOneway";
import { getGradientStyleNormal } from "../layers/style/gradient";
import { getNavigabilityStyleNormal } from "../layers/style/navigability";
import { getEmissionRegulationStyleNormal } from "../layers/style/lez";
import { getEmissionRegulationInteractions } from "../layers/interactions/lez";
import { getRampStyleNormal } from "../layers/style/ramp";
import { getLrtcStyleNormal } from "../layers/style/lrtc";
import { getRampInteractions } from "../layers/interactions/ramp";
import { getLrtcInteractions } from "../layers/interactions/lrtc";
import {
  getCurvatureStyleNormalOrbisSD,
  getCurvatureStyleNormalGenesis,
  getCurvatureStyleNormalOrbisHD,
} from "../layers/style/curvature";
import { getCrosslinkStyleNormal } from "../layers/style/crosslink";
import { getCrosslinkInteractions } from "../layers/interactions/crosslink";
import { getHDMapStyleNormal } from "../layers/style/hdmap";
import { getHDMapInteractions } from "../layers/interactions/hdmap";
import { getHDLaneBorderStyleNormal } from "../layers/style/hdlaneborder";
import { getInteractions as getOnewayInternalInteractions } from "../layers/interactions/genericInternal";
import { getStyleNormal as getOnewayInternalStyleNormal } from "../layers/style/genericInternal";
import { getInteractions as getHDLanerestrictionInternalInteractions } from "../layers/interactions/genericInternal";
import { getStyleNormal as getHDLanerestrictionInternalStyleNormal } from "../layers/style/genericInternal";
import { getInteractions as getSDLanerestrictionInternalInteractions } from "../layers/interactions/genericInternal";
import { getStyleNormal as getSDLanerestrictionInternalStyleNormal } from "../layers/style/genericInternal";
import { getInteractions as getDCWInternalInteractions } from "../layers/interactions/genericInternal";
import { getStyleNormal as getDCWInternalStyleNormal } from "../layers/style/genericInternal";
import { getInteractions as getTTNavInternalInteractions } from "../layers/interactions/ttnavInternal";
import { getStyleNormal as getTTNavStyleNormal } from "../layers/style/ttnavInternal";
import { getModerationInteractions } from "../layers/interactions/moderation";
import { getModerationStyleNormal } from "../layers/style/moderation";
import { addWFSLayerAndControl } from "./WFSLayersAndControls";
import {
  addFGBLayerAndControl,
  concatenateFeatureFields,
  customizeFeatureId,
  enableIfAccessible,
  getPreviousMonthsUrls,
} from "./FGBLayersAndControls";
import {
  getDCWInternalMonths,
  getHDLanerestrictionInternalMonths,
  getSDLanerestrictionInternalMonths,
  getOnewayInternalMonths,
} from "../parameters/parameters";
import { addCrosslinkHoverLayer } from "../layers/CrosslinkHoverLayer";
import { getCrosslinkLayerHander } from "../layers/featureinfohandlers/CrosslinkLayerHandler";
import { defaultHoverStyles } from "../layers/style/hover/defaultHoverStyle";
import {
  curvatureAtJunctionHoverStylesOrbisSD,
  curvatureHoverStyles,
  curvatureHoverStylesGenesis,
  curvatureHoverStylesOrbisHD,
  curvatureHoverStylesOrbisSD,
} from "../layers/style/hover/curvatureHoverStyle";
import { getHDLaneBorderInteractions } from "../layers/interactions/hdlaneborder";
import { getHDLaneFunctionStyleNormal } from "../layers/style/hdlanefunction";
import { getHDLaneFunctionInteractions } from "../layers/interactions/hdlanefunction";
import { getHDLaneRestrictionStyleNormal } from "../layers/style/hdLaneRestriction";
import { getHDLaneRestrictionInteractions } from "../layers/interactions/hdLaneRestriction";
import {
  getCurvatureInteractionsGenesis,
  getCurvatureInteractionsOrbisHD,
  getCurvatureInteractionsOrbisSD,
} from "../layers/interactions/curvature";
import { getHDLaneWidthStyleNormal } from "../layers/style/hdLaneWidth";
import { getHDLaneWidthInteractions } from "../layers/interactions/hdLaneWidth";
import { getOsmLanesNormStyleNormal } from "../layers/style/osmLanesNorm";
import { getOsmLanesNormInteractions } from "../layers/interactions/osmLanesNorm";
import { getControlledAccessStyleNormal } from "../layers/style/controlledAccess";
import { getControlledAccessInteractions } from "../layers/interactions/controlledAccess";
import { curvatureAtJunctionArcHandler } from "../layers/addfeaturehandlers/CurvatureAtJunctionArcHandler";
import { curvatureLinearHandler } from "../layers/addfeaturehandlers/CurvatureLinearHandler";
import { crosslinkCoverageHandler } from "../layers/addfeaturehandlers/CrosslinkCoverageHandler";
import { getCaJStyleNormalOrbisSD } from "../layers/style/curvatureAtJunction";
import { getCaJInteractionsOrbisSD } from "../layers/interactions/curvatureAtJunction";
import {
  getSDLaneRestrictionHovStyleNormal,
  getSDLaneRestrictionStyleNormal,
} from "../layers/style/sdLaneRestriction";
import { getSDLaneRestrictionInteractions } from "../layers/interactions/sdLaneRestriction";

export function addLayersAndControls(
  map,
  azureLoginControl,
  featureInfoControl,
  target,
) {
  // one way

  //curvature
  const curvatureCollapse = getCollapsible("Curvature");
  const onewayCollapse = getCollapsible("Oneway");
  const dcwCollapse = getCollapsible("Dualcarriageway");
  const navCollapse = getCollapsible("Navigability");
  const gradientCollapse = getCollapsible("Gradient");
  const hdCollapse = getCollapsible("HD");
  const lezCollapse = getCollapsible("LEZ");
  const lanerestriction = getCollapsible("Lane Restrictions");
  const rampCollapse = getCollapsible("Ramp");

  target.appendChild(onewayCollapse);
  target.appendChild(navCollapse);
  target.appendChild(dcwCollapse);
  target.appendChild(lezCollapse);
  target.appendChild(rampCollapse);

  target.appendChild(gradientCollapse);
  target.appendChild(curvatureCollapse);

  target.appendChild(hdCollapse);
  target.appendChild(lanerestriction);

  addWFSLayerAndControl({
    layerName: "One way dev 28798",
    url: process.env.ORBIS_WFS_ONEWAY_DEV_28798_URL,
    role: process.env.ORBIS_WFS_ONEWAY_DEV_ROLE,
    style: getOnewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: onewayCollapse,
    map: map,
    getInteractions: getOnewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "One way prod 21591",
    url: process.env.ORBIS_WFS_ONEWAY_PROD_21591_URL,
    role: process.env.ORBIS_WFS_ONEWAY_PROD_ROLE,
    style: getOnewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: onewayCollapse,
    map: map,
    getInteractions: getOnewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // osm one way
  addWFSLayerAndControl({
    layerName: "OSM one way dev 17772",
    url: process.env.ORBIS_WFS_OSM_ONEWAY_DEV_17772_URL,
    role: process.env.ORBIS_WFS_OSM_ONEWAY_DEV_ROLE,
    style: getOsmOnewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: onewayCollapse,
    map: map,
    getInteractions: getOnewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "OSM one way prod 26874",
    url: process.env.ORBIS_WFS_OSM_ONEWAY_PROD_26874_URL,
    role: process.env.ORBIS_WFS_OSM_ONEWAY_PROD_ROLE,
    style: getOsmOnewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: onewayCollapse,
    map: map,
    getInteractions: getOnewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // dual carriageway
  addWFSLayerAndControl({
    layerName: "Dual carriageway dev 22398",
    url: process.env.ORBIS_WFS_DCW_DEV_22398_URL,
    role: process.env.ORBIS_WFS_DCW_DEV_ROLE,
    style: getDualCarriagewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: dcwCollapse,
    map: map,
    getInteractions: getDualCarriagewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "Dual carriageway prod 28200",
    url: process.env.ORBIS_WFS_DCW_PROD_28200_URL,
    role: process.env.ORBIS_WFS_DCW_PROD_ROLE,
    style: getDualCarriagewayStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: dcwCollapse,
    map: map,
    getInteractions: getDualCarriagewayInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // tt-navigabilility
  addWFSLayerAndControl({
    layerName: "TT-Navigability dev 19150",
    url: process.env.ORBIS_WFS_NAVIGABILITY_DEV_19150_URL,
    role: process.env.ORBIS_WFS_NAVIGABILITY_DEV_ROLE,
    style: getNavigabilityStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: navCollapse,
    map: map,
    getInteractions: getNavigabilityInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "TT-Navigability prod 20063",
    url: process.env.ORBIS_WFS_NAVIGABILITY_PROD_20063_URL,
    role: process.env.ORBIS_WFS_NAVIGABILITY_PROD_ROLE,
    style: getNavigabilityStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: navCollapse,
    map: map,
    getInteractions: getNavigabilityInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // osm-navigability
  addWFSLayerAndControl({
    layerName: "OSM-Navigability dev 27657",
    url: process.env.ORBIS_WFS_OSMNAV_DEV_27657_URL,
    role: process.env.ORBIS_WFS_NAVIGABILITY_DEV_ROLE,
    style: getNavigabilityStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: navCollapse,
    map: map,
    getInteractions: getNavigabilityInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "OSM-Navigability prod 11442",
    url: process.env.ORBIS_WFS_OSMNAV_PROD_11442_URL,
    role: process.env.ORBIS_WFS_NAVIGABILITY_PROD_ROLE,
    style: getNavigabilityStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: navCollapse,
    map: map,
    getInteractions: getNavigabilityInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // gradient
  addWFSLayerAndControl({
    layerName: "Gradient hd dev 30426 [disabled]",
    url: process.env.ORBIS_WFS_GRADIENT_DEV_30426_URL,
    role: process.env.ORBIS_WFS_GRADIENT_HD_DEV_ROLE,
    style: getGradientStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: gradientCollapse,
    map: map,
    getInteractions: getGradientInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "Gradient dev 13999",
    url: process.env.ORBIS_WFS_GRADIENT_DEV_13999_URL,
    role: process.env.ORBIS_WFS_GRADIENT_DEV_ROLE,
    style: getGradientStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: gradientCollapse,
    map: map,
    getInteractions: getGradientInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "Gradient prod 11880",
    url: process.env.ORBIS_WFS_GRADIENT_PROD_11880_URL,
    role: process.env.ORBIS_WFS_GRADIENT_PROD_ROLE,
    style: getGradientStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: gradientCollapse,
    map: map,
    getInteractions: getGradientInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "Genesis SD gradient",
    target: gradientCollapse,
    map: map,
    getInteractions: getGradientInteractions,
    sortField: "inserted_at",
    urls: [process.env.GENESIS_GRADIENT_FLATGEOBUF_URL],
    style: getGradientStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "Gradient DEM prod 18758",
    url: process.env.ORBIS_WFS_GRADIENT_DEM_PROD_18758_URL,
    role: process.env.ORBIS_WFS_GRADIENT_DEM_PROD_ROLE,
    style: getGradientStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: gradientCollapse,
    map: map,
    getInteractions: getGradientInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  //curvature
  addWFSLayerAndControl({
    layerName: "LM Curvature prod 20906",
    url: process.env.ORBIS_WFS_CURVATURE_PROD_20906_URL,
    role: process.env.ORBIS_WFS_CURVATURE_HAPT_PROD_HD_ROLE,
    style: getCurvatureStyleNormalOrbisHD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisHD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisHD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "LM Curvature dev 50761",
    url: process.env.ORBIS_WFS_CURVATURE_DEV_50761_URL,
    role: process.env.ORBIS_WFS_CURVATURE_HAP_DEV_HD_ROLE,
    style: getCurvatureStyleNormalOrbisHD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisHD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisHD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "LM2RM Curvature prod 15751",
    url: process.env.ORBIS_WFS_CURVATURE_PROD_15751_URL,
    role: process.env.ORBIS_WFS_CURVATURE_PROD_ROLE,
    style: getCurvatureStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisSD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "LM2RM Curvature dev 15916",
    url: process.env.ORBIS_WFS_CURVATURE_DEV_15916_URL,
    role: process.env.ORBIS_WFS_CURVATURE_DEV_ROLE,
    style: getCurvatureStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisSD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "RM Curvature prod 23405",
    url: process.env.ORBIS_WFS_OSM_CURVATURE_PROD_23405_URL,
    role: process.env.ORBIS_WFS_OSM_CURVATURE_PROD_ROLE,
    style: getCurvatureStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisSD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "RM Curvature dev 15702",
    url: process.env.ORBIS_WFS_OSM_CURVATURE_DEV_15702_URL,
    role: process.env.ORBIS_WFS_OSM_CURVATURE_DEV_ROLE,
    style: getCurvatureStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisSD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStyles("#695f01")],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "RM Curvature Cariad prod 97905",
    url: process.env.ORBIS_WFS_OSM_CURVATURE_PROD_97905_URL,
    role: process.env.ORBIS_WFS_OSM_CURVATURE_CARIAD_PROD_ROLE,
    style: getCurvatureStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsOrbisSD(),
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "CaJ RM prod 64504",
    url: process.env.ORBIS_WFS_OSM_CAJ_PROD_64504_URL,
    role: process.env.ORBIS_WFS_OSM_CAJ_PROD_ROLE,
    style: getCaJStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCaJInteractionsOrbisSD(),
    featureInfoHandlers: [],
    // CaJ draws its own travel-direction arrows on the offset line, so the generic
    // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
    // and visibly off the displayed line — leave it out, keep only the curvature circle.
    hoverStyleFunctions: [curvatureAtJunctionHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureAtJunctionArcHandler],
  });

  addWFSLayerAndControl({
    layerName: "CaJ RM dev 66578",
    url: process.env.ORBIS_WFS_OSM_CAJ_DEV_66578_URL,
    role: process.env.ORBIS_WFS_OSM_CAJ_DEV_ROLE,
    style: getCaJStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCaJInteractionsOrbisSD(),
    featureInfoHandlers: [],
    // CaJ draws its own travel-direction arrows on the offset line, so the generic
    // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
    // and visibly off the displayed line — leave it out, keep only the curvature circle.
    hoverStyleFunctions: [curvatureAtJunctionHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureAtJunctionArcHandler],
  });

  addWFSLayerAndControl({
    layerName: "LM-derived CaJ dev 32286",
    url: process.env.ORBIS_WFS_HD2SD_CAJ_DEV_32286_URL,
    role: process.env.ORBIS_WFS_HD2SD_CAJ_DEV_ROLE,
    style: getCaJStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCaJInteractionsOrbisSD(),
    featureInfoHandlers: [],
    // CaJ draws its own travel-direction arrows on the offset line, so the generic
    // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
    // and visibly off the displayed line — leave it out, keep only the curvature circle.
    hoverStyleFunctions: [curvatureAtJunctionHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureAtJunctionArcHandler],
  });

  addWFSLayerAndControl({
    layerName: "LM-derived CaJ prod 62511",
    url: process.env.ORBIS_WFS_LM2RM_CAJ_PROD_62511_URL,
    role: process.env.ORBIS_WFS_LM2RM_CAJ_PROD_ROLE,
    style: getCaJStyleNormalOrbisSD,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: curvatureCollapse,
    map: map,
    getInteractions: getCaJInteractionsOrbisSD(),
    featureInfoHandlers: [],
    // CaJ draws its own travel-direction arrows on the offset line, so the generic
    // defaultHoverStyles arrow (anchored to the raw, un-offset end) is both redundant
    // and visibly off the displayed line — leave it out, keep only the curvature circle.
    hoverStyleFunctions: [curvatureAtJunctionHoverStylesOrbisSD()],
    addFeatureHandlers: [curvatureAtJunctionArcHandler],
  });

  addFGBLayerAndControl({
    layerName: "Genesis RM Curvature",
    target: curvatureCollapse,
    map: map,
    getInteractions: getCurvatureInteractionsGenesis(),
    sortField: "inserted_at",
    urls: [process.env.GENESIS_CURVATURES_FLATGEOBUF_URL],
    style: getCurvatureStyleNormalGenesis,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStylesGenesis()],
    addFeatureHandlers: [curvatureLinearHandler],
  });

  addWFSLayerAndControl({
    layerName: "Crosslink prod 32804 (incl. HAPT)",
    url: process.env.ORBIS_WFS_CROSSLINK_32804_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getCrosslinkStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getCrosslinkInteractions,
    featureInfoHandlers: [
      getCrosslinkLayerHander(addCrosslinkHoverLayer(map).getSource()),
    ],
    addFeatureHandlers: [crosslinkCoverageHandler],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "LM Lane Restrictions prod 88259",
    url: process.env.ORBIS_WFS_HDLANERESTRICTION_88259_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getHDLaneRestrictionStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getHDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "LM Lane Restrictions dev 91567",
    url: process.env.ORBIS_WFS_HDLANERESTRICTION_91567_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_DEV_ROLE,
    style: getHDLaneRestrictionStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getHDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "RM Lane Restrictions dev 26744 - HOV",
    url: process.env.ORBIS_WFS_SDLANERESTRICTION_26744_URL,
    role: process.env.ORBIS_WFS_SDLANERESTRICTION_DEV_ROLE,
    style: getSDLaneRestrictionHovStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getSDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "RM Lane Restrictions dev 26744 - Vehicle Access",
    url: process.env.ORBIS_WFS_SDLANERESTRICTION_26744_URL,
    role: process.env.ORBIS_WFS_SDLANERESTRICTION_DEV_ROLE,
    style: getSDLaneRestrictionStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getSDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "RM Lane Restrictions prod 21620 - HOV",
    url: process.env.ORBIS_WFS_SDLANERESTRICTION_21620_URL,
    role: process.env.ORBIS_WFS_SDLANERESTRICTION_PROD_ROLE,
    style: getSDLaneRestrictionHovStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getSDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "RM Lane Restrictions prod 21620 - Vehicle Access",
    url: process.env.ORBIS_WFS_SDLANERESTRICTION_21620_URL,
    role: process.env.ORBIS_WFS_SDLANERESTRICTION_PROD_ROLE,
    style: getSDLaneRestrictionStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getSDLaneRestrictionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "RM Lane Restrictions prod 21620 - internals",
    target: lanerestriction,
    map: map,
    getInteractions: getSDLanerestrictionInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.SDLANERESTRICTION_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX,
      getSDLanerestrictionInternalMonths(),
    ),
    style: getSDLanerestrictionInternalStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "RM Lane Restrictions prod 21620 - moderations",
    target: lanerestriction,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "last_moderated_at",
    urls: [process.env.SDLANERES_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "last_moderated_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "LM Lane Restrictions internals prod",
    target: lanerestriction,
    map: map,
    getInteractions: getHDLanerestrictionInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.HDLANERESTRICTION_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX,
      getHDLanerestrictionInternalMonths(),
    ),
    style: getHDLanerestrictionInternalStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "LM Lane Restrictions moderations",
    target: lanerestriction,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "last_moderated_at",
    urls: [process.env.LANERES_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "last_moderated_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "LM Lane Function 38434",
    url: process.env.ORBIS_WFS_HDLANEFUNCTION_38434_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_DEV_ROLE,
    style: getHDLaneFunctionStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getHDLaneFunctionInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // addWFSLayerAndControl({
  //   layerName: "HD lane function 38434 (restriction view)",
  //   url: process.env.ORBIS_WFS_HDLANEFUNCTION_38434_URL,
  //   role: process.env.ORBIS_WFS_HDLANERESTRICTION_DEV_ROLE,
  //   style: getHDLaneRestrictionStyleNormal,
  //   azureLoginControl: azureLoginControl,
  //   featureInfoControl: featureInfoControl,
  //   div: hdlanerestriction,
  //   map: map,
  //   getInteractions: getHDLaneRestrictionInteractions,
  //   featureInfoHandlers: [],
  //   hoverStyleFunctions: [defaultHoverStyles],
  // });

  addWFSLayerAndControl({
    layerName: "HD Basemap 29351 (incl HAPT)",
    url: process.env.ORBIS_WFS_HDLANEFUNCTION_38434_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getHDMapStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getHDMapInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "HD Lane borders 29351 (incl HAPT)",
    url: process.env.ORBIS_WFS_HDLANEFUNCTION_38434_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getHDLaneBorderStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getHDLaneBorderInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // lane width
  addWFSLayerAndControl({
    layerName: "HD Lane width dev 16712",
    url: process.env.ORBIS_WFS_HDLANEWIDTH_16712_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getHDLaneWidthStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getHDLaneWidthInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "HD Lane width prod 49829",
    url: process.env.ORBIS_WFS_HDLANEWIDTH_49829_URL,
    role: process.env.ORBIS_WFS_HDLANERESTRICTION_PROD_ROLE,
    style: getHDLaneWidthStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getHDLaneWidthInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "LRTC HD dev 74020",
    url: process.env.ORBIS_WFS_LRTC_DEV_74020_URL,
    role: process.env.ORBIS_WFS_LRTC_DEV_ROLE,
    style: getLrtcStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getLrtcInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStyles("#5880b7")],
  });

  addWFSLayerAndControl({
    layerName: "LRTC HD prod 93924",
    url: process.env.ORBIS_WFS_LRTC_PROD_93924_URL,
    role: process.env.ORBIS_WFS_LRTC_PROD_ROLE,
    style: getLrtcStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: hdCollapse,
    map: map,
    getInteractions: getLrtcInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles, curvatureHoverStyles("#5880b7")],
  });

  addWFSLayerAndControl({
    layerName: "Osm Lanes Norm prod 11361",
    url: process.env.ORBIS_WFS_OSMLANESNORM_11361_URL,
    role: process.env.ORBIS_WFS_OSMLANESNORM_PROD_ROLE,
    style: getOsmLanesNormStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lanerestriction,
    map: map,
    getInteractions: getOsmLanesNormInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  // lez
  addWFSLayerAndControl({
    layerName: "LEZ dev 21372",
    url: process.env.ORBIS_WFS_LEZ_DEV_21372_URL,
    role: process.env.ORBIS_WFS_LEZ_DEV_ROLE,
    style: getEmissionRegulationStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lezCollapse,
    map: map,
    getInteractions: getEmissionRegulationInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addWFSLayerAndControl({
    layerName: "LEZ prod 22666",
    url: process.env.ORBIS_WFS_LEZ_PROD_22666_URL,
    role: process.env.ORBIS_WFS_LEZ_PROD_ROLE,
    style: getEmissionRegulationStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: lezCollapse,
    map: map,
    getInteractions: getEmissionRegulationInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  // ramp
  addWFSLayerAndControl({
    layerName: "Controlled Access prod 16158",
    url: process.env.ORBIS_WFS_RAMP_DEV_90537_URL,
    role: process.env.ORBIS_WFS_RAMP_DEV_ROLE,
    style: getControlledAccessStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: rampCollapse,
    map: map,
    getInteractions: getControlledAccessInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "Ramp dev 90537",
    url: process.env.ORBIS_WFS_RAMP_DEV_90537_URL,
    role: process.env.ORBIS_WFS_RAMP_DEV_ROLE,
    style: getRampStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: rampCollapse,
    map: map,
    getInteractions: getRampInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });
  addWFSLayerAndControl({
    layerName: "Ramp prod 54757",
    url: process.env.ORBIS_WFS_RAMP_PROD_54757_URL,
    role: process.env.ORBIS_WFS_RAMP_PROD_ROLE,
    style: getRampStyleNormal,
    azureLoginControl: azureLoginControl,
    featureInfoControl: featureInfoControl,
    div: rampCollapse,
    map: map,
    getInteractions: getRampInteractions,
    featureInfoHandlers: [],
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "Orbis one way internals dev",
    target: onewayCollapse,
    map: map,
    getInteractions: getOnewayInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.ONEWAY_STATEMENTS_FLATGEOBUF_URL_DEV_PREFIX,
      getOnewayInternalMonths(),
    ),
    style: getOnewayInternalStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "Orbis one way internals prod",
    target: onewayCollapse,
    map: map,
    getInteractions: getOnewayInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.ONEWAY_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX,
      getOnewayInternalMonths(),
    ),
    style: getOnewayInternalStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "TT-Navigability internals dev",
    target: navCollapse,
    map: map,
    getInteractions: getTTNavInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.TTNAV_STATEMENTS_FLATGEOBUF_URL_DEV_PREFIX,
      5,
    ),
    style: getTTNavStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "TT-Navigability internals prod",
    target: navCollapse,
    map: map,
    getInteractions: getTTNavInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.TTNAV_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX,
      5,
    ),
    style: getTTNavStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "Orbis one way moderations",
    target: onewayCollapse,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "last_moderated_at",
    urls: [process.env.ONEWAY_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "last_moderated_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "TT Navigability moderations",
    target: navCollapse,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "last_moderated_at",
    urls: [process.env.TTNAV_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "last_moderated_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "OSM Navigability moderations",
    target: navCollapse,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "last_moderated_at",
    urls: [process.env.OSMNAV_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "last_moderated_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "DCW internals prod",
    target: dcwCollapse,
    map: map,
    getInteractions: getDCWInternalInteractions,
    sortField: "inserted_at",
    urls: getPreviousMonthsUrls(
      process.env.DCW_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX,
      getDCWInternalMonths(),
    ),
    style: getDCWInternalStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["way_id", "inserted_at"]),
    ),
    hoverStyleFunctions: [defaultHoverStyles],
  });

  addFGBLayerAndControl({
    layerName: "Dual carriageway moderations",
    target: dcwCollapse,
    map: map,
    getInteractions: getModerationInteractions,
    sortField: "inserted_at",
    urls: [process.env.DCW_MODERATIONS_FLATGEOBUF_URL],
    style: getModerationStyleNormal,
    featureInfoControl: featureInfoControl,
    transformFeature: customizeFeatureId(
      concatenateFeatureFields(["id", "inserted_at"]),
    ),
    minZoom: 10,
    settingConfigurationFn: enableIfAccessible,
    hoverStyleFunctions: [defaultHoverStyles],
  });
}

function getCollapsible(name) {
  const details = document.createElement("details");
  const summary = document.createElement("summary");
  summary.append(name);
  details.appendChild(summary);
  return details;
}
